function initContactForm(formElement) {
  const submit = formElement.querySelector("button[type='submit']");
  const recaptchaWidget = formElement.querySelector('.js-recaptcha');
  let formIsValid = false;

  if (recaptchaWidget) {
    let widgetId = renderReCaptcha(formElement, recaptchaWidget, function (widgetId) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', formElement.getAttribute('action'));
      xhr.send(new FormData(formElement));

      xhr.onload = function () {
        if (xhr.status === 200) {
          console.log(xhr.responseText);
          let response = JSON.parse(xhr.responseText);
          if (response.ok) {
            showMessage('Děkujeme za zprávu, brzy se Vám ozveme zpět.', 'success');
            grecaptcha.reset(widgetId);
            formElement.reset();
            return;
          } else {
            showMessage('Něco se rozbilo, zkuste to prosím později.', 'success');
          }
        }

        grecaptcha.reset(widgetId);
        showMessage('Něco se rozbilo, zkuste to prosím později.', 'success');
      };

      xhr.onerror = function () {
        showMessage(JSON.parse(xhr.responseText), 'error');
        grecaptcha.reset(widgetId);
        submit.removeAttribute('disabled');
      };
    });

    submit.addEventListener('click', function (event) {
      event.preventDefault();
      if (validateInputs(formElement) === true) {
        formIsValid = true;
        grecaptcha.execute(widgetId);
      }
    });
  }
}

function showMessage(message, type) {
  const form = document.querySelector('.contact__form');
  const formMessage = document.querySelector('#contact-form-message');
  formMessage.textContent = message;
  form.style.display = 'none';
  formMessage.style.display = 'block';

  setTimeout(function () {
    form.style.display = 'block';
    formMessage.style.display = 'none';
  }, 3000);
}

function showErrorMessage(message, inputClass) {
  input = document.querySelector(`.${inputClass}`);
  input.textContent = message;
  input.style.display = 'block';
  input.style.marginTop = '5px';
}

function validateInputs(formElement) {
  let isValid = true;
  document.querySelector('.name-error').style.display = 'none';
  document.querySelector('.email-error').style.display = 'none';
  document.querySelector('.message-error').style.display = 'none';
  // Validate the 'name' input
  const nameInput = formElement.querySelector('input[name="contact_form[name]"]');
  if (nameInput.value.length < 2 || nameInput.value.length > 50) {
    showErrorMessage('Vaše jméno musí obsahovat alespoň 2 znaky a nesmí obsahovat více než 50 znaků.', 'name-error');
    isValid = false;
  }

  // Validate the 'email' input
  const emailInput = formElement.querySelector('input[name="contact_form[email]"]');
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(emailInput.value)) {
    showErrorMessage('Email není ve správném formátu.', 'email-error');
    isValid = false;
  }

  // Validate the 'message' input
  const messageInput = formElement.querySelector('textarea[name="contact_form[message]"]');
  if (messageInput.value.length < 20 || messageInput.value.length > 500) {
    showErrorMessage('Vaše zpráva musí obsahovat alespoň 20 znaků a nesmí obsahovat více než 500 znaků.', 'message-error');
    isValid = false;
  }

  return isValid;
}
